//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    showPassword: false,
    usuario: null,
    password: null,
  }),
  methods: {
    async submit() {
      await this.$store.dispatch("auth/login", this.$data)

      this.$router.push({ name: "dashboard" })
    },
  },
}
